import React from 'react';
import classes from '../styles.module.scss';
import formClasses from '../../styles.module.scss';
import { createCn } from '../../../helpers/utils';

const cn = createCn('ai-settings', classes);

interface BotRunnerGroupProps {
  enabled: boolean;
  onEnabledChange: (value: boolean) => void;
  url: string;
  onUrlChange: (value: string) => void;
  apiKeySet: boolean;
  apiKeyValue: string;
  onApiKeyChange: (value: string) => void;
}

const BotRunnerGroup = ({
  enabled,
  onEnabledChange,
  url,
  onUrlChange,
  apiKeySet,
  apiKeyValue,
  onApiKeyChange,
}: BotRunnerGroupProps) => {
  return (
    <div className={cn('group')}>
      <div className={cn('group-title')}>Бот-раннер</div>

      <label className={cn('checkbox-row')}>
        <input type="checkbox" checked={enabled} onChange={(e) => onEnabledChange(e.target.checked)} />
        Включён
      </label>

      <div className={formClasses['form-group']}>
        <label>URL бот-раннера</label>
        <input
          value={url}
          onChange={(e) => onUrlChange(e.target.value)}
          placeholder="https://bot-runner.example.com"
          autoComplete="off"
        />
      </div>

      <div className={formClasses['form-group']}>
        <label>
          API-ключ{' '}
          <span className={cn('key-badge', { set: apiKeySet })}>
            {apiKeySet ? 'ключ задан' : 'ключ не задан'}
          </span>
        </label>
        <input
          type="password"
          value={apiKeyValue}
          onChange={(e) => onApiKeyChange(e.target.value)}
          placeholder="Оставьте пустым, чтобы не менять"
          autoComplete="new-password"
        />
      </div>

      <div className={cn('group-desc')}>
        Оркестрация бота-участника встреч. Сам бот — отдельный self-hosted сервис; здесь задаётся
        его адрес/ключ.
      </div>
    </div>
  );
};

export default BotRunnerGroup;
